import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Home from '../pages/Home/Home';
import About from '../pages/About/About';
import Introduction from '../pages/About/Introduction';
import History from '../pages/About/History';
import Contact from '../pages/About/Contact';
import Departments from '../pages/Academics/Departments';
import CommonPage from '../pages/CommonPage';
import Research from '../pages/Academics/Research';
import Academics from '../pages/Academics/Academics';
import Majors from '../pages/Academics/Majors';
import Campus from '../pages/Campus/Campus';
import CampusDetail from '../pages/Campus/CampusDetail';
import Layout from '../components/Layout/Layout';
import Admissions from '../pages/Admissions/Admissions';

// 创建路由配置
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'about',
        children: [
          {
            path: '',
            element: <About />,
          },
          {
            path: 'introduction',
            element: <Introduction />,
          },
          {
            path: 'history',
            element: <History />,
          },
          {
            path: 'contact',
            element: <Contact />,
          },
        ],
      },
        {
          path: 'academics',
          children: [
            {
              path: '',
              element: <Academics />,
            },
            {
              path: 'departments',
              element: <Departments />,
            },
            {
              path: 'majors',
              element: <Majors />,
            },
            {
              path: 'research',
              element: <Research />,
            },
          ],
        },
        {
          path: 'admissions',
          element: <Admissions />,
        },
      {
        path: 'students',
        element: <CommonPage title="学生工作" description="羊小羊学生工作信息" />,
      },
      {
        path: 'international',
        element: <CommonPage title="国际交流" description="羊小羊国际交流信息" />,
      },
      { 
        path: 'campus', 
        children: [
          { path: '', element: <Campus /> },
          { path: ':id', element: <CampusDetail /> }
        ] 
      },
    ],
  },
]);

export default router;